import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { FiCheck } from 'react-icons/fi';

import { Container } from './styles';

interface CheckboxProps {
  id?: string;
  name?: string;
  isSelected?: boolean;
  clickId?: string;
  round?: boolean;
  customColor?: string;
  onClick?(): void;
}

const Checkbox: React.FunctionComponent<CheckboxProps> = ({
  id = '',
  name = '',
  clickId,
  isSelected = false,
  round = false,
  customColor = '',
  onClick,
}) => {
  const [isChecked, setIsChecked] = useState(isSelected);

  const foreignState = useMemo(() => {
    if (isSelected && isChecked) return 'checked';

    if (isChecked) return 'checked';

    return 'not-checked';
  }, [isSelected, isChecked]);

  const toggleCheck = useCallback(() => {
    setIsChecked(!isChecked);
    onClick && onClick();
  }, [isChecked, onClick]);

  useEffect(() => {
    setIsChecked(isSelected);
  }, [isSelected]);

  return (
    <Container
      onClick={toggleCheck}
      id={clickId}
      round={round}
      customColor={customColor}
    >
      <div className="check-wrapper">
        <input type="checkbox" name={name} id={id} />
        <div className={`check-icon ${foreignState}`}>
          <FiCheck size={16} />
        </div>
      </div>
    </Container>
  );
};

export default Checkbox;
